import React, { Component, Fragment } from 'react';
import SpaceBookingsList from './SpaceBookingsList';

export default class SpaceBookingPage extends Component {
  render() {
    return (
      <Fragment>
        <SpaceBookingsList />
      </Fragment>
    );
  }
}
